// Table Module - CSS-only module for various table styles
import './table.scss';

// CSS-only module - no JavaScript functionality needed
const BceTable = {
    // This module is CSS-only, no initialization required
    // The styles are automatically applied when imported
};

export default BceTable;